module.exports = __webpack_public_path__ + "static/media/desktop-tower.71ce57be.png";